module.exports = __webpack_public_path__ + "static/media/clock-icon-glowing.e7348d93.png";